import Textfield from "@atlaskit/textfield";
import Button from "@atlaskit/button/new";
import React, {useEffect} from "react";
import {SecurityService} from "navigation-common/SecurityService";
import hintImgBackground from "../../../assets/img/Image-level1-empty.svg";
import hintImgTeaser from "../../../assets/img/Image-level2-empty.svg";
import hintImgBackgroundDark from "../../../assets/img/Image-level1-empty-dark.svg";
import hintImgTeaserDark from "../../../assets/img/Image-level2-empty-dark.svg";
import hintImgError from "../../../assets/img/image-resolve-error.svg";
import hintImgErrorDark from "../../../assets/img/image-resolve-error-dark.svg";

export interface ImageModalProps {
    onImageChange: (imageUrl: string) => void,
    onCancel: () => void,
    imageType: string,
    imageUrl?: string,
}

export const ImageLinkForm = (props: ImageModalProps) => {
    const [imageUrl, setImageUrl] = React.useState<string>("")
    const [imageURLFieldHasError, setImageURLFieldHasError] = React.useState<boolean>(false);

    useEffect(() => {
        if (props.imageUrl) {
            setImageUrl(props.imageUrl);
        }
    }, []);

    async function validateImageURL(imageUrl: string) {
        if (!imageUrl) {
            setImageURLFieldHasError(false);
            return false;
        }
        const isValid = SecurityService.isValidImageUrl(imageUrl) && await isImgLoadable(imageUrl);
        setImageURLFieldHasError(!isValid);
        return isValid;
    }

    function isImgLoadable(imgUrl: string) {
        const img = new Image();
        img.src = imgUrl;
        return new Promise((resolve) => {
            img.onload = () => resolve(true);
            img.onerror = () => resolve(false);
        });
    }

    const removeImage = () => {
        setImageUrl("");
        setImageURLFieldHasError(false);
    }

    return (
        <div className={"imageLinkForm"}>
            <div className={"image-preview-wrapper"}>
                {!imageUrl && (
                    <div className={"hint-wrapper"}>
                        <img src={props.imageType === "background" ? hintImgBackground : hintImgTeaser} className={"hint lightMode"} alt={"hint"}/>
                        <img src={props.imageType === "background" ? hintImgBackgroundDark : hintImgTeaserDark} className={"hint darkMode"} alt={"hint"}/>
                        <p>Enter an URL to insert an image.</p>
                    </div>
                )}

                {imageUrl &&
                    <>
                        {imageURLFieldHasError ?
                            <div className={"hint-wrapper"}>
                                <img src={hintImgError} className={"hint lightMode"} alt={"error"}/>
                                <img src={hintImgErrorDark} className={"hint darkMode"} alt={"error"}/>
                                <p className={"errorMessage"}>URL is invalid / Image could not be loaded</p>
                            </div>
                            : <img className={"image-preview"} alt={""} src={imageUrl}/>
                        }
                    </>
                }
            </div>
            <div className={"image-url"}>
                {props.imageType === "background" && <label>Background image URL</label>}
                {props.imageType === "teaser" && <label>Teaser image URL</label>}
                <Textfield
                    placeholder="https://image.com" value={imageUrl}
                    isInvalid={imageURLFieldHasError}
                    onChange={(event) => {
                        validateImageURL(event.currentTarget.value);
                        setImageUrl(event.currentTarget.value);
                    }}
                />
            </div>
            <div className={"actions"}>
                <Button appearance={"default"} onClick={removeImage} isDisabled={!imageUrl}>Remove</Button>
                <div style={{display: "flex", gap: "6px"}}>
                    <Button appearance={"subtle"} onClick={props.onCancel}>Cancel</Button>
                    <Button isDisabled={imageURLFieldHasError} appearance={"primary"}
                            onClick={() => props.onImageChange(imageUrl)}>Confirm</Button>
                </div>
            </div>
        </div>);
}
